import type { useRouter, Match, Route, MatchedRoute } from 'react-resource-router';
import { getAnalyticsWebClientPromise } from '@atlassian/jira-product-analytics-web-client-async';

let matchedRoute: MatchedRoute | null = null;

export const setMatchedRoute = (route?: Route | null, match?: Match) => {
	if (route && match) {
		matchedRoute = { route, match };
	}
};

export const getMatchedRoute = () => matchedRoute;

export const getRouteName = () => matchedRoute?.route.name ?? 'unknown';

export const getUserLocation = () => `${matchedRoute?.route.group ?? 'unknown'}:${getRouteName()}`;

// TODO import from @atlassian/jira-router once part of the public API
export type RouterState = ReturnType<typeof useRouter> extends [infer S, unknown] ? S : never;

let previousRouterState: RouterState | null = null;
let previousSubProduct = '';

export const setPreviousRouterState = (state: RouterState | null) => {
	previousRouterState = state;
};

export const getPreviousRouterState = () => previousRouterState;

export const setPreviousSubProduct = (subProduct: string | null) => {
	previousSubProduct = subProduct || '';
};

export const getPreviousSubProduct = () => previousSubProduct;

export const setSubProduct = (subproduct: string | null) => {
	if (subproduct === null) {
		return;
	}

	if (previousSubProduct !== subproduct) {
		setPreviousSubProduct(subproduct);
	}

	getAnalyticsWebClientPromise().then((client) => {
		client.setSubProduct(subproduct);
	});
};
